import { createFileRoute, redirect } from '@tanstack/react-router'
import { withRoutePermissions } from '~/utils/rbac'

// Chaque onglet est une URL distincte ; /sellers redirige vers l'onglet par défaut
// (« Vendeurs ») directement au chargement de la route.
export const Route = createFileRoute('/_authenticated/sellers/')({
  staticData: {
    permission: ['read', 'sellers'],
  },
  beforeLoad: () => {
    throw redirect({ to: '/sellers/sellers' })
  },
})
withRoutePermissions(Route)
